<template>
  <ul class="PaB-product__prices">
    <li v-for="(variant, priceIndex) in product.prices" :key="variant.key" class="PaB-product__option"
      @click="showDetailsWithVariant($event, priceIndex)">
      <pretty-money :amt="variant.price_cents | currency({cents: true, whole_dollars: true})"
        class="PaB-product__price" />
      <span class="PaB-product__unit" v-if="product.combine_weights || product.prices.length > 1">{{ +variant.unit }}
        {{ singularizeWeight(variant.unit_type, variant.unit) }}</span>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
$gutter: 10px;

.PaB-product__prices {
  padding: 0;
  position: relative;
  margin: 0 ($gutter/2 * -1);
}
.PaB-product__option {
  border: 1px solid rgba(#7f7f7f, 0.4); // TODO: Dark Mode.
  border-radius: 3px;
  display: inline-block;
  margin: $gutter/2;
  padding: 4px 8px;
  text-align: center;
  cursor: pointer;
}
.PaB-product__price {
  font-size: 18px;
}
.PaB-product__unit {
  display: block;
  font-size: 13px;
  opacity: 0.7;
}
</style>

<script>
export default {
  props: ['product'],
  methods: {
    showDetailsWithVariant (event, priceIndex) {
      this.$emit('show-details-with-variant', event, priceIndex)
    },
    singularizeWeight (unittype, amt) {
      if (amt <= 1.0) {
        return unittype.slice(0, -1)
      } else {
        return unittype
      }
    }
  }
}
</script>
